export default __webpack_public_path__ + "certificate-shape.png";